// Canonical car locations as stored in the DB (carro.ubicacion) and used by
// the AddCar/Sell forms and the stock filter checkboxes. Keep the values in
// sync with those — the backend filter does an exact match on them.
export const UBICACIONES = [
  "USA",
  "Puerto Cortez",
  "Tegucigalpa",
  "Transito",
  "San Lorenzo",
];
